(() => {
  if (window.skybikeOfferCartInitialized) return;
  window.skybikeOfferCartInitialized = true;

  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    document.querySelectorAll('[data-skybike-direct-cart][data-busy="true"]').forEach((form) => {
      form.dataset.busy = 'false';
      form.querySelector('[name="add"]').disabled = false;
    });
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-skybike-direct-cart]');
    if (!form) return;
    event.preventDefault();
    if (form.dataset.busy === 'true') return;
    form.dataset.busy = 'true';
    const button = form.querySelector('[name="add"]');
    const error = form.querySelector('[data-cart-error]');
    button.disabled = true;
    error.textContent = '';
    const root = window.Shopify?.routes?.root || '/';
    const request = async (path, options = {}) => {
      const response = await fetch(root + path, options);
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || 'Unable to update your cart. Please try again.');
      return data;
    };
    try {
      const variantId = String(new FormData(form).get('id'));
      let cart = await request('cart.js');
      let selected = cart.items.find((item) => String(item.variant_id) === variantId && Object.keys(item.properties || {}).length === 0 && !item.selling_plan_allocation);
      if (!selected) {
        await request('cart/add.js', { method: 'POST', body: new FormData(form) });
        cart = await request('cart.js');
        selected = cart.items.find((item) => String(item.variant_id) === variantId && Object.keys(item.properties || {}).length === 0 && !item.selling_plan_allocation);
      }
      if (!selected) throw new Error('Unable to confirm your reservation. Please try again.');
      const updates = {};
      cart.items.forEach((item) => {
        if (item.handle === 'skybike-founding-reservation' || (item.handle === 'skybike-coreride-ai-powered-full-body-recumbent-exercise-bike' && item.key !== selected.key)) updates[item.key] = 0;
      });
      if (selected.quantity !== 1) updates[selected.key] = 1;
      if (Object.keys(updates).length) {
        await request('cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        });
      }
      window.location.assign(form.querySelector('[name="return_to"]').value);
    } catch (exception) {
      error.textContent = exception.message || 'Unable to update your cart. Please try again.';
      button.disabled = false;
      form.dataset.busy = 'false';
    }
  });
})();
